interface Props {
  label?: string;
  value?: string;
  onChange?: (e: React.ChangeEvent<HTMLTextAreaElement>) => void;
  inputClassName?: string;
  labelClassName?: string;
  placeholder?: string;
  error?: boolean;
}

export const FormTextarea = ({
  label,
  value,
  onChange,
  inputClassName,
  labelClassName,
  placeholder,
  error,
  ...rest
}: Props) => {
  return (
    <div className="mb-4">
      <p
        className={`font-satoshi text-dark text-sm font-medium mb-3 ${labelClassName}`}
      >
        {label}
      </p>
      <textarea
        {...rest}
        value={value}
        onChange={onChange}
        className={`w-full min-h-32 px-4 py-[11px] bg-sky-lighter border ${
          error ? "border-red-base" : "border-gray-border"
        } ${
          error ? "focus:border-red-base" : "focus:border-focused-border"
        } rounded font-satoshi text-base text-dark font-medium outline-none ${inputClassName}`}
        placeholder={placeholder}
      />
    </div>
  );
};
